import axios from 'axios'
import { isLocalStorageEnabled } from '@/utils'

export const endpoints = {
  baseURL: process.env.API_URL || 'https://peopleoverprof.it/api/',
}

export const HTTP = axios.create({
  baseURL: endpoints.baseURL,
  withCredentials: true,
})

HTTP.interceptors.request.use((config) => {
  if (isLocalStorageEnabled() && localStorage.getItem('token')) {
    config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`
  }

  return config
})

export default HTTP
